export default __webpack_public_path__ + "static/media/logo_ouigo_grande_vitesse.0bcce9cd.svg";